import { Components, Theme } from '@mui/material/styles';

import MuiAlert from './MuiAlert';
import MuiButton from './MuiButton';
import MuiCheckbox from './MuiCheckbox';
import { MuiCssBaseline } from './MuiCssBaseline';
import MuiLink from './MuiLink';
import MuiLoadingButton from './MuiLoadingButton';
import MuiMenuItem from './MuiMenuItem';
import MuiRadio from './MuiRadio';
import MuiStepConnector from './MuiStepConnector';
import MuiTextField from './MuiTextField';
import { MuiUseMediaQuery } from './MuiUseMediaQuery';

export function overrideComponents(theme: Theme): Components<Theme> {
  return Object.assign(
    MuiButton(theme),
    MuiTextField(theme),
    MuiLink(theme),
    MuiCssBaseline(),
    MuiMenuItem(theme),
    MuiAlert(theme),
    MuiStepConnector(theme),
    MuiRadio(theme),
    MuiCheckbox(theme),
    MuiUseMediaQuery(),
    MuiLoadingButton(),
  );
}
